import { Box, Typography } from "@mui/material";
import { Partnership } from "../../db_access/partnership";
import ButtonAccept from "./ButtonAccept";
import ButtonReject from "./ButtonReject";

const InvitationPartnership = ({ invitation, setRefresh, showAction = true, isReceiverPOV = true }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          paddingX: 1,
        }}>
        <Box>
          <Typography
            sx={{
              textAlign: "left",
              fontFamily: "Poppins",
              fontWeight: 100,
            }}>
            <Box component={"span"} sx={{ color: "black" }}>
              {invitation.sender_name}{" "}
            </Box>
            invites
            <Box component={"span"} sx={{ color: "black" }}>
              {" "}
              {invitation.receiver_name}{" "}
            </Box>
            to partnership
          </Typography>
        </Box>
        <Box sx={{ gap: 0.5, display: "flex" }}>
          <Box
            sx={{
              display: showAction && invitation.status === "Pending" ? "block" : "none",
            }}>
            <ButtonAccept invitation_id={invitation.id} setRefresh={setRefresh} request={Partnership.accept} />
          </Box>
          <Box
            sx={{
              display: showAction && invitation.status === "Pending" ? "block" : "none",
            }}>
            <ButtonReject invitation_id={invitation.id} setRefresh={setRefresh} request={Partnership.reject} />
          </Box>
          <Box
            sx={{
              display: !showAction || invitation.status !== "Pending" ? "block" : "none",
            }}>
            <Typography
              sx={{
                textAlign: "left",
                fontFamily: "Poppins",
                fontWeight: 100,
              }}>
              {invitation.status}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ fontFamily: "Poppins", fontWeight: 100, textAlign: "right" }}>Created at: {invitation.timestamp.split(" GMT")[0]}</Typography>
        <Typography sx={{ fontFamily: "Poppins", fontWeight: 100, textAlign: "right" }}>Last Modified: {invitation.last_modified.split(" GMT")[0]}</Typography>
      </Box>
    </Box>
  );
};

export default InvitationPartnership;
